export const defaultData = {
	email_verification: {
		enable: "yes",
		verification_page_id: "none",
		redirect_after_verification: "none",
		login_after_verification: "yes",
		email_update_reverify: "no",
		exclude_user_roles: ["administrator"],
	},
	messages: {
		invalid_key: "Sorry, activation key is not valid.",
		activation_sent: "Verification mail has been sent.",
		verify_email: "Verify your email first!",
		registration_success:
			'Registration complete. Please verify the mail first, then visit the <a href="%s">login page</a>.',
		verification_success: "Thanks for Verifying.",
		verification_fail: "Sorry! Verification failed.",
		please_wait: "Please wait.",
		mail_instruction:
			"Please check your mail inbox and follow the instruction. don\\'t forget to check spam or trash folder.",
		redirect_after_verify: "You will redirect after verification",
		not_redirect: "Click if not redirect automatically",
		title_checking_verification: "Checking Verification",
		title_sending_verification: "Sending verification mail",
		captcha_error: "Captcha not resolved.",
		otp_sent_success: "OTP has been sent successfully.",
		otp_sent_error: "OTP generated, but unable to send mail.",
	},
	email_otp: {
		enable_default_login: "no",
		required_email_verified: "no",
		allow_password: "yes",
		length: "6",
		character_source: ["uppercase", "lowercase"],
	},
	isspammy: {
		report_comment_spam: "no",
		report_comment_trash: "no",
		block_comment: "no",
		comment_form_notice: "no",
		comment_form_notice_text: "",
		block_register: "no",
		block_login: "no",
	},
	spam_protection: {
		enable_domain_block: "no",
		blocked_domain: [""],
		allowed_domain: [""],
		enable_username_block: "no",
		blocked_username: [""],
		generic_mail_block: "no",
		blocked_generic_mail: [""],
	},
	logo_id: "",
	mail_wpautop: "yes",
	email_templates_data: {
		user_registered: {
			name: "New User Registration",
			enable: "yes",
			email_bcc: "",
			email_from_name: "",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "New user submitted - {site_url}",
			html: '',
		},
		email_confirmed: {
			name: "Email Verification Confirmed",
			enable: "yes",
			email_bcc: "",
			email_from_name: "",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "New user confirmed - {site_url}",
			html: '',
		},
		email_resend_key: {
			name: "Resend Activation Key",
			enable: "yes",
			email_bcc: "",
			email_from_name: "",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "Please verify account - {site_url}",
			html: '',
		},
		send_mail_otp: {
			name: "Send Mail OTP",
			enable: "yes",
			email_bcc: "",
			email_from_name: "",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "OTP - {site_url}",
			html: "",
		},
		send_magic_login_url: {
			name: "Send Magic Login URL",
			enable: "yes",
			email_bcc: "",
			email_from_name: "",
			email_from: "",
			reply_to_name: "",
			reply_to: "",
			subject: "Magic Login - {site_url}",
			html: '',
		},
	},
	recaptcha: {
		version: "v2_checkbox",
		sitekey: "",
		secretkey: "",
		default_login_page: "no",
		default_registration_page: "no",
		default_lostpassword_page: "no",
		comment_form: "no",
	},
	unverified: {
		delete_user: "no",
		delete_max_number: "20",
		delay: "720",
		delete_user_interval: "daily",
		existing_user_verified: "no",
		existing_user_verified_interval: "daily",
	},
	disable: {
		new_user_notification_email: "no",
	},
	tools: {
		mail_from: "",
		mail_from_name: "",
	},
};